//Basics
export const SET_MODEL = 'product/SET_MODEL'
export const SET_LINE = 'product/SET_LINE'
export const SET_DESCRIPTION = 'product/SET_DESCRIPTION'
export const SET_ACTIVE = 'product/SET_ACTIVE'

//Images
export const SET_COVER_IMAGE = 'product/SET_COVER_IMAGE'
export const SET_COVER_IMAGE_NAME = 'product/SET_COVER_IMAGE_NAME'
export const ADD_GALLERY_IMAGE = 'product/ADD_GALLERY_IMAGE'
export const REMOVE_GALLERY_IMAGE = 'product/REMOVE_GALLERY_IMAGE'

//Variants
export const ADD_VARIANT = 'product/ADD_VARIANT'
export const REMOVE_VARIANT = 'product/REMOVE_VARIANT'

//Variant Item
export const ADD_VARIANT_ITEM = 'product/ADD_VARIANT_ITEM'
export const REMOVE_VARIANT_ITEM = 'product/REMOVE_VARIANT_ITEM'

//Reset Product
export const RESET_PRODUCT = 'product/RESET_PRODUCT'

//Clone Product
export const CLONE_BEFORE_UPDATE = 'product/CLONE_BEFORE_UPDATE'

const INITIAL_STATE = {
    product: {
        model: '',
        productLine: '',
        description: '',
        coverImage: null,
        coverImageName: null,
        active: false,
        gallery: {},
        variants: {}
    },
    beforeUpdate: null
}

const mutateProductProperty = state => property => value => ({
    ...state,
    product: {
        ...state.product, [property]: value
    }
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_MODEL:
            return mutateProductProperty(state)('model')(action.payload)

        case SET_LINE:
            return mutateProductProperty(state)('productLine')(action.payload)

        case SET_DESCRIPTION:
            return mutateProductProperty(state)('description')(action.payload)
        case SET_ACTIVE:
            return mutateProductProperty(state)('active')(action.payload)

        case SET_COVER_IMAGE:
            return mutateProductProperty(state)('coverImage')(action.payload)
        case SET_COVER_IMAGE_NAME:
            return mutateProductProperty(state)('coverImageName')(action.payload)
        case ADD_GALLERY_IMAGE:
            return ({
                ...state,
                product: {
                    ...state.product,
                    gallery: { ...state.product.gallery, [action.payload.id]: action.payload }
                }
            })

        case REMOVE_GALLERY_IMAGE:
            let clonedGallery = { ...state.product.gallery }
            delete clonedGallery[action.payload]
            return ({ ...state, product: { ...state.product, gallery: clonedGallery } })

        case ADD_VARIANT:
            return ({
                ...state,
                product: {
                    ...state.product,
                    variants: { ...state.product.variants, [action.payload.id]: action.payload }
                }
            })

        case REMOVE_VARIANT:
            let clonedVariants = { ...state.product.variants }
            delete clonedVariants[action.payload]
            return ({ ...state, product: { ...state.product, variants: clonedVariants } })

        case ADD_VARIANT_ITEM:
            return ({
                ...state,
                product: {
                    ...state.product,
                    variants: {
                        ...state.product.variants,
                        [action.payload.variantID]: {
                            ...state.product.variants[action.payload.variantID],
                            items: {
                                ...state.product.variants[action.payload.variantID].items,
                                [action.payload.newItem.id]: action.payload.newItem
                            }
                        }
                    }
                }
            })

        case REMOVE_VARIANT_ITEM:
            let clonedVariantItems = { ...state.product.variants[action.payload.variantID].items }
            delete clonedVariantItems[action.payload.itemID]
            return ({
                ...state,
                product: {
                    ...state.product, variants: {
                        ...state.product.variants,
                        [action.payload.variantID]: {
                            ...state.product.variants[action.payload.variantID],
                            items: clonedVariantItems
                        }
                    }
                }
            })

        case RESET_PRODUCT:
            return ({ ...state, ...INITIAL_STATE })
        case CLONE_BEFORE_UPDATE:
            return ({ ...state, beforeUpdate: { ...state.product } })
        default:
            return state
    }
}

export const setModel = payload => ({ type: SET_MODEL, payload })
export const setLine = payload => ({ type: SET_LINE, payload })
export const setDescription = payload => ({ type: SET_DESCRIPTION, payload })
export const setActive = payload => ({ type: SET_ACTIVE, payload })
export const setCoverImage = payload => ({ type: SET_COVER_IMAGE, payload })
export const setCoverImageName = payload => ({ type: SET_COVER_IMAGE_NAME, payload })
export const addGalleryImage = payload => ({ type: ADD_GALLERY_IMAGE, payload })
export const removeGalleryImage = payload => ({ type: REMOVE_GALLERY_IMAGE, payload })
export const addVariant = payload => ({ type: ADD_VARIANT, payload })
export const removeVariant = payload => ({ type: REMOVE_VARIANT, payload })
export const addVariantItem = payload => ({ type: ADD_VARIANT_ITEM, payload })
export const removeVariantItem = payload => ({ type: REMOVE_VARIANT_ITEM, payload })
export const resetProduct = () => ({ type: RESET_PRODUCT })
export const cloneBeforeUpdate = () => ({ type: CLONE_BEFORE_UPDATE })



// WEBPACK FOOTER //
// ./src/ducks/Product.js